import type { ComparisonResult, DismissRecommendationProductRequest } from '@fig/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import apiClient from '../../lib/api-client';

import { comparisonKeys } from './useComparison';

interface DismissRecommendationProductResponse {
  success: boolean;
  dismissalId: string;
}

async function dismissRecommendationProduct(
  request: DismissRecommendationProductRequest
): Promise<DismissRecommendationProductResponse> {
  const response = await apiClient.post<DismissRecommendationProductResponse>(
    '/comparisons/dismiss-product',
    request
  );
  return response.data;
}

export function useDismissRecommendationProduct() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: dismissRecommendationProduct,
    onSuccess: (_data, variables) => {
      queryClient.setQueryData<ComparisonResult | null>(
        comparisonKeys.detail(variables.opportunityId),
        (current) => {
          if (!current) return current;
          const matches = current.matches.filter(
            (match) => match.productId !== variables.productId
          );
          return {
            ...current,
            matches,
            matchCount: matches.length,
          };
        }
      );
      void queryClient.invalidateQueries({
        queryKey: comparisonKeys.detail(variables.opportunityId),
      });
    },
  });
}
